import { useState } from 'react';

import { UI } from '../../../../constants';
import { useUserAction } from '../../../common/hooks/useUserAction';

export const useCloseLiveChat = () => {
  const [isDisabled, setDisabled] = useState<boolean>(false);
  const emit = useUserAction(UI.CLOSE_LIVE_CHAT);

  const closeChat = () => {
    setDisabled(true);

    return emit({ endedBy: 'user' }).then((success) => {
      setDisabled(success);
    });
  };

  return <const>{
    isDisabled,
    closeChat,
  };
};
